// Generated by CoffeeScript 1.9.3
(function() {
    var request = require('request');
    var mkFhir = require('../fhir');
    var Q = require('q');

    var adapter = {
        defer: Q.defer,
        http: function(args) {
            var deff = Q.defer();
            args.body = args.data;
            args.json = true;
            if(args.debug){
                console.log('DEBUG[node]: (requrest)', args); 
            }
            request(args, function(err, response, body) {
                var headers = function(x) {return response.headers[x.toLowerCase()];};
                var resp = {data: body, status: response.statusCode, headers: headers, config: args};
                if(args.debug){
                    console.log('DEBUG[node]: (responce)', resp); 
                }
                if (err || response.statusCode > 399) {deff.reject(resp);} else {deff.resolve(resp);}
            }) ;
            return deff.promise;
        }
    };

    module.exports = function(config) {
        return mkFhir(config, adapter);
    };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/fhir.js/src/adapters/node.js
// module id = 487
// module chunks = 0